import { AnimatedLogoModule } from '../animated-logo/animated-logo.module';
import { BlockUIModule } from 'primeng/blockui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SpinnerComponent } from './spinner.component';

@NgModule({
  declarations: [SpinnerComponent],
  imports: [CommonModule, BlockUIModule,AnimatedLogoModule],
  exports: [SpinnerComponent],
})
export class SpinnerModule {}
